import { InjectionToken } from '@angular/core';
import { FloatingPanelRef } from './floating-panel.types';

/**
 * Injection-token waarmee een content-component dat in een **floating** panel
 * gemount wordt zijn eigen {@link FloatingPanelRef} kan ophalen — bv. om het
 * paneel te herpositioneren wanneer de inhoud van grootte verandert (small↔full
 * toggle). Wordt enkel aangeboden in floating-modus; in een gedockte tab is er
 * geen ref (de content injecteert het `optional`).
 */
export const FLOATING_PANEL_REF = new InjectionToken<FloatingPanelRef>('FLOATING_PANEL_REF');
